import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import { getMatchPlayers } from '@shared/libs/match-detail'

const EndOver = ({ data, id, inning }) => {
  const players = getMatchPlayers()
  const oBowler = players[data?.aBowlers[0]?.oBowler?._id] || data?.aBowlers[0]?.oBowler
  return (
    <>
      <div className={`${styles.overHead} d-flex justify-content-between align-items-center`} id={id}>
        <h3 className="mb-0 small-head">
          {'Over'} {data?.sOver}
        </h3>
        <div className={`${styles.info} text-center`}>
          <p className="mb-0 d-flex big-text font-bold">
            {data?.aOverScores?.map((ball, index) => {
              let ballClass = `${styles.run} rounded-pill`
              if (ball === '0') {
                ballClass += ` ${styles.runZero}`
              } else if (ball === 'w') {
                ballClass += ' redSix'
              } else if (ball === '4') {
                ballClass += ' bg-success border-success text-white'
              } else if (ball === '6') {
                ballClass += ` ${styles.runBoundary} bg-success text-white`
              } else if (ball === '4b' || ball === '4lb') {
                ballClass += ` ${styles.runBoundary}`
              }
              return (
                <span className={ballClass} key={index}>
                  {index ? ' ' : ''}
                  {ball}
                </span>
              )
            })}
          </p>
        </div>
      </div>
      <div className={`${styles.over} d-flex flex-wrap flex-xl-nowrap align-items-xl-center`} id={id}>
        <div className={`${styles.info} flex-grow-1 d-flex flex-md-column justify-content-evenly`}>
          <div className="mb-1 big-text font-bold">
            <span className={styles.textOrange}>{inning?.map(i => i?.nInningNumber === data?.nInningNumber && i?.sShortName)}</span>:{' '}
            {data?.sScore}
          </div>
        </div>
        <div className={(data?.aBatters.length !== 0 || data?.aBowlers.length !== 0) && styles.brBtm}>
          {data?.aBatters.length !== 0 && (
            <div className={`${styles.info} ${styles.partners}`}>
              {data?.aBatters?.map((bat, index) => {
                const oBatter = players[bat?.oBatter?._id] || bat?.oBatter
                return (
                  <p className={styles.batterText} key={index}>
                    <span>
                      {oBatter?.eTagStatus === 'a' ? (
                        <CustomLink href={`/${oBatter?.oSeo?.sSlug}`}>{bat?.oBatter?.sFullName || bat?.oBatter?.sShortName}</CustomLink>
                      ) : (
                        bat?.oBatter?.sFullName || bat?.oBatter?.sShortName
                      )}
                    </span>{' '}
                    <span className="ms-1">
                      {bat?.nRuns}({bat?.nBallFaced})
                    </span>
                  </p>
                )
              })}
            </div>
          )}
          {data?.aBowlers.length !== 0 && <div className={styles.divider}></div>}
          {data?.aBowlers.length !== 0 && (
            <div className={`${styles.info} ms-3`}>
              <p className="mb-1 ">
                {oBowler?.eTagStatus === 'a' ? (
                  <CustomLink href={`/${oBowler?.oSeo?.sSlug}`}>
                    {data?.aBowlers[0]?.oBowler?.sFullName || data?.aBowlers[0]?.oBowler?.sShortName}
                  </CustomLink>
                ) : (
                  data?.aBowlers[0]?.oBowler?.sFullName || data?.aBowlers[0]?.oBowler?.sShortName
                )}
              </p>
              <p className="mb-0">
                {data?.aBowlers[0]?.sOvers}-{data?.aBowlers[0]?.nMaidens}-{data?.aBowlers[0]?.nRunsConceded}-{data?.aBowlers[0]?.nWickets}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

EndOver.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  inning: PropTypes.array,
  index: PropTypes.number
}

export default EndOver
